const mapItems = (arr: Array<any> | null, fio = false) => {
  return arr !== null
    ? arr.map((item) => {
        if (fio) return { value: item.id, text: item.fio };
        return { value: item.id, text: item.name };
      })
    : [];
};

export { mapItems };



// WEBPACK FOOTER //
// ./src/tools/mapitems.ts